// extracted by mini-css-extract-plugin
export default {"container":"_1xLBls5CWivbLY0jh4IFjF"};